import Vue from "vue";
import VuetifyDialogPromise from "vuetify-dialog-promise";

Vue.use( VuetifyDialogPromise, {
    locale : window.$cc_ui_locale,
    snackbarX : "left",
    snackbarY : "bottom",
    snackbarTimeout : 12000
} );
